@if (loading()) {
  <se-fe-spinner [seFeDataSize]="900" [seFeDataCenter]="true"></se-fe-spinner>
} @else {
  @if (showSearchToolbar()) {
    <se-fe-toolbar
      class="catalog-table-toolbar"
      [seFeDataQuery]="query() || ''"
      (seFeQueryChange)="handleSearch($event)"></se-fe-toolbar>
  }

  @if (catalogs().length > 0 && datasource()) {
    <se-fe-table-wrapper class="catalog-table-wrapper">
      <table
        seFeTable
        [seFeTableSort]="initialSort()"
        title="Catalogs table"
        class="catalog-table"
        [dataSource]="datasource()"
        (seFeSortChange)="sortChange($event)">
        <ng-container seFeColumnDef="Name">
          <th class="table-header" seFeHeaderCell *seFeHeaderCellDef seFeDataRef="name" seFeTableSortHeader>Name</th>
          <td seFeCell *seFeCellDef="let row" class="table-row">
            <a seFeLink [routerLink]="getCatalogLink(row)" target="_self">{{ row.name }}</a>
          </td>
        </ng-container>

        <ng-container seFeColumnDef="Number of Products">
          <th class="table-header" seFeHeaderCell *seFeHeaderCellDef>Number of Products</th>
          <td seFeCell *seFeCellDef="let row">{{ row.products_count ?? 0 }}</td>
        </ng-container>

        <ng-container seFeColumnDef="Created At">
          <th class="table-header" seFeHeaderCell *seFeHeaderCellDef seFeDataRef="created_at" seFeTableSortHeader>
            Created At
          </th>
          <td seFeCell *seFeCellDef="let row">{{ row.created_at | date: 'mediumDate' }}</td>
        </ng-container>

        <ng-container seFeColumnDef="Delete">
          <th class="catalog-table__delete-cell" seFeHeaderCell *seFeHeaderCellDef></th>
          <td class="catalog-table__delete-cell" seFeCell *seFeCellDef="let row">
            <se-fe-icon-button (click)="requestDeleteCatalog(row, $event)">
              <se-fe-icon
                seFeDataName="trash"
                seFeDataSize="500"
                [seFeDataAriaLabel]="'Delete ' + row.name"
                seFeDataColor="gray-700"></se-fe-icon>
            </se-fe-icon-button>
          </td>
        </ng-container>

        <tr seFeHeaderRow *seFeHeaderRowDef="displayedColumns"></tr>
        <tr [seFeRow]="row" *seFeRowDef="let row; columns: displayedColumns"></tr>
      </table>
    </se-fe-table-wrapper>
  } @else if (query()?.trim()) {
    <se-fe-empty-state class="empty-state" seFeDataTitle="No catalogs found"></se-fe-empty-state>
  } @else {
    <se-fe-empty-state class="empty-state" seFeDataTitle="You don't have any catalogs yet">
      <se-fe-icon seFeEmptyStateIcon seFeDataName="spot_pricetag" seFeDataSize="950"></se-fe-icon>
      Create catalogs to control which products you sell in your registrations. For example, make a baseball-specific
      catalog to sell relevant products in your baseball registrations.
      <se-fe-button seFeEmptyStateAction seFeDataEmphasis="high" (click)="requestCreateCatalog($event)">
        Create catalog
      </se-fe-button>
    </se-fe-empty-state>
  }

  @if (catalogs().length) {
    <se-fe-pagination
      [seFeDataPaginationOptions]="paginationOptions()"
      (seFePaginationChange)="paginationChange($event)"></se-fe-pagination>
  }
}
